import { Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import type { ActionCardTone } from './action-card.types';

const TONE_CLASS: Readonly<Record<ActionCardTone, string>> = {
  info: 'action-card__icon--info',
  success: 'action-card__icon--success',
  warning: 'action-card__icon--warning',
  report: 'action-card__icon--report',
  users: 'action-card__icon--users',
  neutral: '',
};

@Component({
  selector: 'app-action-card',
  imports: [RouterModule, MatCardModule, MatIconModule],
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss'],
})
export class ActionCardComponent {
  readonly heading = input.required<string>();
  readonly description = input.required<string>();
  readonly icon = input.required<string>();
  readonly link = input.required<string | unknown[]>();

  readonly actionText = input<string>('Acessar');

  readonly disabled = input<boolean>(false);

  readonly tone = input<ActionCardTone>('neutral');

  protected readonly toneClass = computed(() => TONE_CLASS[this.tone()]);
  protected readonly routerTarget = computed(() => (this.disabled() ? null : this.link()));
  protected readonly ariaDisabled = computed(() => (this.disabled() ? 'true' : null));
  protected readonly tabIndex = computed(() => (this.disabled() ? '-1' : null));
}
